module.exports = __webpack_public_path__ + "static/img/technologybg2.4eb8a1f4.png";